import { ChangeDetectorRef, Component, QueryList, ViewChildren } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { SharedModule } from 'src/app/layouts/full/shared/shared.module';
import { ClientsService } from 'src/app/services/clients.service';
import { CustomerFormService } from 'src/app/services/customer-form.service';
import { ProductsService } from 'src/app/services/products.service';
import { ServicesService } from 'src/app/services/services.service';
import { UserService } from 'src/app/services/user.service';
import { CustomComponentComponent, DialogPosition } from '../custom-component/custom-component.component';
import { Client } from 'src/app/models/client.model';
import { Service } from 'src/app/models/service.model';
import Swal from 'sweetalert2';
import { CreateCustomFormComponent } from '../create-custom-form/create-custom-form.component';
import { environment } from 'src/environments/environment';
import { User } from 'src/app/models/user.model';
import { Clinic } from 'src/app/models/clinic.model';
import { ClinicService } from 'src/app/services/clinic.service';
import { Roles, ScanType } from 'src/app/layouts/full/shared/Enums';
import { PrescriptionTemplate, PrescriptionTemplatesService } from 'src/app/services/prescription-templates.service';
import { lastValueFrom } from 'rxjs';

@Component({
  selector: 'app-custom-form-details',
  standalone: true,
  imports: [SharedModule, CustomComponentComponent],
  templateUrl: './custom-form-details.component.html',
  styleUrl: './custom-form-details.component.scss',
  providers: [MessageService]
})
export class CustomFormDetailsComponent {
  selectedImage;
  galleryImages;
  selectedQueType;
  selectedQueIndex = 0;
  @ViewChildren(CustomComponentComponent) customComponent: QueryList<CustomComponentComponent>;
  ColumnMode: string
  search = '';
  isSubmitting: boolean = false;
  isFormSubmitting: boolean = false;
  isFormNameSubmitting: boolean = false;
  isDeleting: boolean = false;
  clientList: Client[] = [];
  selectedClient: Client[] = [];
  selectedClinic: Clinic
  isInputChanged = false;
  displayedColumns: string[] = ['typeform', 'questions', 'updated', 'actions'];
  user: User
  clinics: Clinic[] = []
  client: Client
  scanTypes: ScanType[] = [];
  prescriptionTemplates: PrescriptionTemplate[] = [];

  constructor(
    private fb: FormBuilder,
    private customerFormService: CustomerFormService,
    private messageService: MessageService,
    private cd: ChangeDetectorRef,
    public userService: UserService,
    private clientsService: ClientsService,
    private servicesService: ServicesService,
    private productService: ProductsService,
    private router: Router,
    private route: ActivatedRoute,
    private clinicService: ClinicService,
    private prescriptionTemplatesService: PrescriptionTemplatesService
  ) {
    this.user = this.userService.user
    this.galleryImages = this.customerFormService.galleryImages;
    // Create Custom form
    this._initCreateCustomForm();
    this._initUpdateForm();
  }

  imageList = [
    {
      id: 0,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTDZX8bPP_MfyRACtlXyu4P2_e-YzZLop5PV7aT0bLF_LZ-nQlwWwxox-UqPMg6iLTTc8&usqp=CAU'
    },
    {
      id: 1,
      image: 'https://images.squarespace-cdn.com/content/v1/58d1fe00cd0f6829bded7f92/1494562127164-IBDQ97GUJ2JDV49780LB/heel+pain'
    },
    {
      id: 2,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpLRONRNuYCJhBuE5RKug8R5g9MWt71eabQFaMqvBzahlCejbczyKcYnQ4ro29L1rJxzo&usqp=CAU'
    },
    {
      id: 3,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTDZX8bPP_MfyRACtlXyu4P2_e-YzZLop5PV7aT0bLF_LZ-nQlwWwxox-UqPMg6iLTTc8&usqp=CAU'
    },
    {
      id: 4,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTDZX8bPP_MfyRACtlXyu4P2_e-YzZLop5PV7aT0bLF_LZ-nQlwWwxox-UqPMg6iLTTc8&usqp=CAU'
    },
    {
      id: 5,
      image: 'https://images.squarespace-cdn.com/content/v1/58d1fe00cd0f6829bded7f92/1494562127164-IBDQ97GUJ2JDV49780LB/heel+pain'
    },
    {
      id: 6,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTpLRONRNuYCJhBuE5RKug8R5g9MWt71eabQFaMqvBzahlCejbczyKcYnQ4ro29L1rJxzo&usqp=CAU'
    },
    {
      id: 7,
      image: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRTDZX8bPP_MfyRACtlXyu4P2_e-YzZLop5PV7aT0bLF_LZ-nQlwWwxox-UqPMg6iLTTc8&usqp=CAU'
    },
  ]

  private readonly baseQuestionTypes = ['inputText', 'longText', 'email', 'dropdown', 'uniqueChoice', 'multipleChoice', 'customComponents', 'productsList', 'insolesPrescription', 'requiredImages'];

  private readonly baseQuestionTypeArr = [
    {
      type: '文本', questionTypes: [
        { name: '输入文字', value: 'inputText' },
        { name: '长文本', value: 'longText' },
      ]
    },
    {
      type: '联系方式', questionTypes: [
        { name: '电子邮件', value: 'email' },
      ]
    },
    {
      type: 'Choices', questionTypes: [
        { name: '独特的选择', value: 'uniqueChoice' },
        { name: '多项选择', value: 'multipleChoice' },
        { name: '下拉菜单', value: 'dropdown' },
      ]
    },
    {
      type: '其他', questionTypes: [
        { name: '自定义组件', value: 'customComponents' },
        { name: '产品列表', value: 'productsList' },
        { name: '鞋垫处方', value: 'insolesPrescription' },
        { name: '所需图像', value: 'requiredImages' }
      ]
    }

  ]

  questionTypes = [...this.baseQuestionTypes];

  questionTypeArr = this.baseQuestionTypeArr.map((group) => ({
    ...group,
    questionTypes: [...group.questionTypes]
  }));

  questionIcons = {
    inputText: { icon: 'bi bi-input-cursor-text', color: '#369bfb' },
    longText: { icon: 'bi bi-file-text', color: '##369bfb' },
    email: { icon: 'bi bi-envelope', color: '#98cdfc' },
    dropdown: { icon: 'bi bi-menu-button-wide-fill', color: '#d65c99' },
    uniqueChoice: { icon: 'bi bi-ui-radios', color: '#d65c99' },
    multipleChoice: { icon: 'bi bi-ui-checks', color: '#d55b98' },
    customComponents: { icon: 'bi bi-postcard-fill', color: '#fa9e31' },
    productsList: { icon: 'bi bi-box-fill', color: '#adebe4' },
    insolesPrescription: { icon: 'bi bi-box-fill', color: '#4fa198ff' },
    requiredImages: { icon: 'bi bi-box-fill', color: '#1fa76eff' }
  }

  questionForm: FormGroup;
  currentStep: number = 0
  questions: FormArray
  selectedType: string
  choices: FormArray
  components: FormArray
  products: FormArray
  choicesCurrentInd: number = 0
  componentCurrentId: number = 0
  optionCurrentInd: number = 0
  options: FormArray
  isQuestionPopup: boolean = false
  customFormList: any = []
  isEdit: boolean = false
  editedItem: any = [];
  inputCustomForm;
  scanLink: string = 'https://pshm.samcomtechnobrains.com/'
  isScnAccess = false

  visible: boolean = false;
  position: DialogPosition = DialogPosition.Bottom
  uploadControl;
  isModalVisible: boolean = false;
  isFormTypePopup: boolean = false;
  showCustomFormPopup: boolean = false;
  isSubscibed: boolean = false;
  isRequiredQue: boolean = false;
  loading: boolean = true;
  services: Service[];
  productList = [];
  selectedProducts = [];
  questionsList = [];

  createCustomForm: FormGroup;
  selectedImageUrl: string = '';
  updateForm: FormGroup;

  requireScansControl: FormControl;
  requireWeb3DScansControl: FormControl;
  requireNameControl: FormControl;
  requireSurnameControl: FormControl;
  requireShoeSizeControl: FormControl;
  requireVideoControl: FormControl;
  enableShippingControl: FormControl;
  clinicIdControl: FormControl;
  scanningTypeControl: FormControl;
  imageControl: FormControl;
  filteredFormList = [];
  customFormId: string
  customForm
  clientId: string
  currentQuestionControl: any;
  currentQuestionIndex: number;
  selectedLogicOption: string;
  selectedGoToQuestion: number;

  ngOnInit(): void {
    this.applyQuestionTypePermissions();
    this.loadClient()
    this.loadService();
    this.listClients();
    this.getAllCustomForm();
    this.questionForm = this.fb.group({
      name: ['', [Validators.required]],
      userId: [''],
      requireScans: new FormControl(false),
      requireWeb3DScans: new FormControl(false),
      assignedToCustomers: new FormArray([]),
      questions: new FormArray([]),
      required: this.fb.group({
        name: new FormControl(false),
        surname: new FormControl(false),
        shoeSize: new FormControl(false),
        video: new FormControl(false)
      }),
      enableShipping: new FormControl(false),
      clinicId: new FormControl(null),
      scanningType: new FormControl(null)
    });
    this.getAllProduct();

    this.requireScansControl = this.questionForm.get('requireScans') as FormControl
    this.requireWeb3DScansControl = this.questionForm.get('requireWeb3DScans') as FormControl
    this.requireNameControl = this.questionForm.get('required.name') as FormControl
    this.requireSurnameControl = this.questionForm.get('required.surname') as FormControl
    this.requireShoeSizeControl = this.questionForm.get('required.shoeSize') as FormControl
    this.requireVideoControl = this.questionForm.get('required.video') as FormControl
    this.enableShippingControl = this.questionForm.get('enableShipping') as FormControl
    this.clinicIdControl = this.questionForm.get('clinicId') as FormControl
    this.scanningTypeControl = this.questionForm.get('scanningType') as FormControl

    this.customFormId = this.route.snapshot.paramMap.get('id')

    this.scanTypes = Object.values(ScanType)

    // Cargar prescription templates del usuario
    this.loadPrescriptionTemplates();

    // Si deseleccionamos la opción "Require 3D scans" se resetean las opciones que dependen de ella
    this.requireScansControl.valueChanges.subscribe(value => {
      if (!value) {
        this.questionForm.patchValue({
          required: {
            name: false,
            surname: false,
            shoeSize: false,
            video: false
          },
          enableShipping: false,
          clinicId: null,
          scanningType: null
        });
      }
    });

    // Si deseleccionamos "Require web 3D scans", limpiar todos los prescriptionTemplateId
    this.requireWeb3DScansControl.valueChanges.subscribe(value => {
      if (!value) {
        this.clearAllPrescriptionTemplates();
        this.removeWeb3DScansQuestions();
      } else {
        this.addWeb3DScansQuestions();
      }
    });
  }

  private canUseProductsListType(): boolean {
    return !!this.userService.user?.connectedStripeId;
  }

  private applyQuestionTypePermissions(): void {
    const canUseProductsList = this.canUseProductsListType();

    this.questionTypes = canUseProductsList
      ? [...this.baseQuestionTypes]
      : this.baseQuestionTypes.filter((type) => type !== 'productsList');

    this.questionTypeArr = this.baseQuestionTypeArr.map((group) => ({
      ...group,
      questionTypes: canUseProductsList
        ? [...group.questionTypes]
        : group.questionTypes.filter((qtype) => qtype.value !== 'productsList')
    }));
  }

  private blockProductsListWithoutStripe(): boolean {
    if (this.canUseProductsListType()) {
      return false;
    }

    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: 'Products List is only available for users with connected Stripe account.'
    });
    return true;
  }

  getCustomForm() {
    this.customerFormService.getFormById(this.customFormId).subscribe({
      next: (customForm) => {
        this.customForm = customForm
        this.editValue(this.customForm, 0)
      },
      error: (err) => {
        console.error("Error getting custom form: ", err)
      },
    })
  }

  listClients() {
    this.clientsService.getClients().subscribe(clients => {
      this.clientList = clients?.map(({ name, ID, userID, email, bill }) => ({ name, ID, userID, email, bill }));
      this.getCustomForm()
    })
  }

  getAllProduct() {
    this.productService.getAllProduct().subscribe(async (res: any) => {
      this.productList = res.products;
    })
  }

  async loadPrescriptionTemplates() {
    try {
      const clientId = this.userService.user.role === 'ROLE_CUSTOMER'
        ? this.userService.user.client?.id
        : this.clientId;

      if (clientId) {
        this.prescriptionTemplates = await lastValueFrom(
          this.prescriptionTemplatesService.getPrescriptionTemplatesByClientID(clientId)
        );
      }
    } catch (error) {
      console.error('Error loading prescription templates:', error);
      this.prescriptionTemplates = [];
    }
  }

  loadService() {
    this.servicesService.getServices().subscribe((services) => {
      this.services = services
      services.map(service => {
        if (service.name === "Pro features") {
          this.getAllCustomForm();
        }
      })

    });
  }

  openGallery(event: Event, item: any, j: number): void {
    // Prevent the default behavior of the file input
    event.preventDefault();
    event.stopPropagation();

    // Open the gallery dialog or perform other actions here
    this.showDialog('bottom', item, j);

  }

  // Question Image Methods
  onImageToggleChange(questionIndex: number, event: any): void {
    const hasImage = event.checked;
    const questionControl = this.questionsControls.at(questionIndex);

    if (!hasImage) {
      // Clear the image when toggle is turned off
      questionControl.get('image')?.setValue('');
    }
  }

  selectQuestionImage(event: any, questionControl: any, questionIndex: number): void {
    const file = event.target.files[0];
    if (file) {
      this.handleQuestionImageUpload(file, questionControl, questionIndex);
    }
  }

  openQuestionGallery(event: Event, questionControl: any, questionIndex: number): void {
    event.preventDefault();
    event.stopPropagation();

    // Set the current question control for gallery selection
    this.currentQuestionControl = questionControl;
    this.currentQuestionIndex = questionIndex;
    this.showDialog('bottom', questionControl, questionIndex);
  }

  changeQuestionImage(questionControl: any, questionIndex: number): void {
    // Create a temporary file input for changing the image
    const fileInput = document.createElement('input');
    fileInput.type = 'file';
    fileInput.accept = 'image/*';
    fileInput.style.display = 'none';

    fileInput.onchange = (event: any) => {
      const file = event.target.files[0];
      if (file) {
        this.handleQuestionImageUpload(file, questionControl, questionIndex);
      }
    };

    document.body.appendChild(fileInput);
    fileInput.click();
    document.body.removeChild(fileInput);
  }

  private handleQuestionImageUpload(file: File, questionControl: any, questionIndex: number): void {
    const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];

    if (!allowedFileTypes.includes(file.type)) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Invalid file type. Please select a valid image file.'
      });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const name = file.name;
      const base64 = reader.result?.toString();
      if (base64) {
        const blob = base64.split(",")[1];
        Swal.showLoading();

        this.productService.uploadFile(name, blob).subscribe({
          next: (res: any) => {
            questionControl.get('image')?.setValue(res.fileUrl);
            Swal.close();
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: 'Image uploaded successfully'
            });
          },
          error: (error) => {
            Swal.close();
            this.messageService.add({
              severity: 'error',
              summary: 'Error',
              detail: 'Failed to upload image'
            });
          }
        });
      }
    };

    reader.readAsDataURL(file);
  }

  showDialog(position: string, control: any, index: number) {
    this.position = position as DialogPosition;
    this.visible = true;
    this.uploadControl = control;
  }

  showTypeModal() {
    // Marcar todos los controles como touched para activar las validaciones
    this.questionsControls.controls.forEach(control => {
      control.markAllAsTouched();
    });

    // Verificar si hay errores reales después de marcar como touched
    const hasInvalidQuestions = this.questionsControls.controls.some(control => {
      if (control instanceof FormGroup) {
        // Verificar campos requeridos específicamente
        const titleControl = control.get('title');
        const typeControl = control.get('type');

        // Un campo es inválido si está vacío o solo tiene espacios
        const titleInvalid = titleControl && (
          !titleControl.value ||
          titleControl.value.trim() === '' ||
          titleControl.invalid
        );

        const typeInvalid = typeControl && (!typeControl.value || typeControl.invalid);

        return titleInvalid || typeInvalid;
      }
      return control.invalid;
    });

    if (hasInvalidQuestions || this.questionForm.value.name === "") {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please fill all mandatory fields' });
      Swal.fire({
        title: 'Warning',
        text: 'Please fill all mandatory fields',
        icon: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6'
      });
      return false;
    }

    // If the form is valid, set isFormTypePopup to true
    this.isFormTypePopup = true;
    return true
  }


  selectQuestionType(qtype) {
    if (qtype === 'productsList' && this.blockProductsListWithoutStripe()) {
      return;
    }

    this.selectedQueType = qtype;
    this.isFormTypePopup = false;
    this.isRequiredQue = false;
    const questionFormArray = this.questionForm.get('questions') as FormArray;
    questionFormArray.controls.push(this.createQuestion({ type: qtype }))
    if (qtype === 'customComponents') {
      this.addComponent(questionFormArray.length - 1, this.componentCurrentId - 1)
    }
    if (qtype === 'multipleChoice' || qtype === 'uniqueChoice' || qtype === 'requiredImages') {
      this.selectedType = qtype
      this.addChoices(questionFormArray.controls.length - 1, -1)
    }
    this.selectedQueIndex = this.questionsList.length + 1;
    if (this.questionIcons && this.questionIcons[qtype]) {
      this.questionsList = [...this.questionsList, { icon: this.questionIcons[qtype].icon, type: qtype, command: () => this.moveToQuestion(this.selectedQueIndex) }];
      this.setSelectedQuestionIndex(questionFormArray.controls.length - 1, this.questionsList[this.selectedQueIndex - 1]);

      this.cd.detectChanges();
    }
  }

  // This function is used to set the selected question index and update the form with the selected question's information.
  setSelectedQuestionIndex(selectedQueIndex: number, selectedQuestion) {
    // Save data from the previous step before switching
    if (this.currentStep !== selectedQueIndex) {
      const prevStepIndex = this.currentStep;
      const prevType = this.questionForm.value.questions[prevStepIndex]?.type;

      if (prevType === 'customComponents' && this.customComponent) {
        const componentsArray = this.questionsControls.at(prevStepIndex).get("components") as FormArray;
        componentsArray.clear();
        this.customComponent.forEach((component) => {
          const componentVal = component.submit();
          componentsArray.push(componentVal);
        });
      }
    }

    this._updateIndices(selectedQueIndex);
    this.currentStep = selectedQueIndex;
    this.cd.detectChanges();
    this.selectedQueType = selectedQuestion.type;

    this.selectedType = selectedQuestion.type
    if (selectedQuestion.type === 'customComponents') {
      // Obtener los datos RAW del FormArray para pasarlos al componente
      const componentsArray = this.questionsControls.at(selectedQueIndex).get("components") as FormArray;
      this.inputCustomForm = componentsArray.getRawValue();
      this.cd.detectChanges();
    }

    // Load existing logic if it exists (tomar la primera regla del array)
    const currentQuestionControl = this.questionsControls.at(selectedQueIndex);
    const existingLogic = currentQuestionControl.get('logic')?.value;
    if (existingLogic && Array.isArray(existingLogic) && existingLogic.length > 0) {
      // Cargar la primera regla por defecto
      this.selectedLogicOption = existingLogic[0].selectedOption;
      this.selectedGoToQuestion = existingLogic[0].goToIndex;
    } else {
      this.selectedLogicOption = null;
      this.selectedGoToQuestion = null;
    }

    const questionFormArray = this.questionForm.get('questions') as FormArray;
    this.typeChange(this.selectedQueType, questionFormArray.controls.length - 1);
  }

  nextQuestion(step: number, i: number): void {
    console.log("Entro en nextQuestion")
    if (this.questions.controls[i].invalid) {
      alert('Please fill all mendatory field')
    } else {
      // Sincronizar los componentes de la pregunta actual antes de cambiar
      const currentFormType = this.questionForm.value.questions[step] ? this.questionForm.value.questions[step].type : ''
      if (currentFormType === 'customComponents' && this.customComponent) {
        const componentsArray = this.questionsControls.at(step).get("components") as FormArray;
        componentsArray.clear();
        this.customComponent.forEach((component) => {
          const componentVal = component.submit();
          componentsArray.push(componentVal);
        })
      }

      this.cd.detectChanges();
      this.currentStep = step + 1;
      this._updateIndices(this.currentStep);
      this.selectedType = this.questionForm.value.questions[this.currentStep] ? this.questionForm.value.questions[this.currentStep].type : '';


      if (this.isEdit && (this.editedItem.questions.length > this.currentStep)) {
        if (this.selectedType === 'customComponents') {
          this.inputCustomForm = this.componentsControls(this.currentStep).getRawValue();
          this.cd.detectChanges();
        } else {
          this.editedItem.questions[step] = this.questionForm.getRawValue().questions[step];
          this.editValue(this.editedItem, this.currentStep)
        }
      } else {
        if (this.selectedType === 'customComponents') {
          this.inputCustomForm = this.componentsControls(this.currentStep).getRawValue();
          this.cd.detectChanges();
        }
        if (this.selectedType == '' && this.questionForm.value.questions.length === this.currentStep) {
          this.addQuestion();
        }
      }
    }
  }

  backQuestion() {
    if (this.currentStep > 0) {
      // Sincronizar los componentes de la pregunta actual antes de retroceder
      const currentFormType = this.questionForm.value.questions[this.currentStep] ? this.questionForm.value.questions[this.currentStep].type : ''
      if (currentFormType === 'customComponents' && this.customComponent) {
        const componentsArray = this.questionsControls.at(this.currentStep).get("components") as FormArray;
        componentsArray.clear();
        this.customComponent.forEach((component) => {
          const componentVal = component.submit();
          componentsArray.push(componentVal);
        })
      }

      this.currentStep--
      this._updateIndices(this.currentStep);
      this.selectedType = this.questionForm.value.questions &&
        this.questionForm.value.questions[this.currentStep] &&
        this.questionForm.value.questions[this.currentStep].type
        ? this.questionForm.value.questions[this.currentStep].type
        : '';

      if (this.selectedType !== '') {
        this.questionForm.value.questions[this.currentStep] = this.questionForm.getRawValue().questions[this.currentStep];
        this.typeChange(this.selectedType, this.currentStep);
      }

      else {
        this.inputCustomForm = undefined;
        this.typeChange('', this.currentStep)
        this.choices = this.questionsControls.at(this.currentStep).get("choices") as FormArray;
        this.choicesCurrentInd = this.choices.length - 1
      }
    }
  }

  addCustomForm(): void {
    this.createCustomForm.reset();
    this.showCustomFormPopup = true;
  }

  addQuestion(): void {
    this.questions = this.questionForm.get('questions') as FormArray;
    this.questions.push(this.createQuestion(''));
  }


  // This function is called when the value of the "name" form control is changed.
  changeFormName(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.questionsList[this.selectedQueIndex].name = inputValue;
  }

  changeTitle(questionIndex: number, event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.questionsList[questionIndex].title = inputValue;
    this.questionsControls.updateValueAndValidity();
  }

  changeSubTitle(questionIndex: number, event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value || '';

    if (this.questionsList && this.questionsList[questionIndex]) {
      this.questionsList[questionIndex].subtitle = inputValue;
    }

    if (this.questionsControls) {
      this.questionsControls.updateValueAndValidity();
    }
  }

  changeOptionsList(questionIndex: number, event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value;
    this.questionsList[questionIndex].options = inputValue;
    this.questionsControls.updateValueAndValidity();
  }

  moveToQuestion(queIndex) {
    this.currentStep = queIndex;
  }

  setQueType(i: number) {
    const currentType = (this.questionsControls.controls[i] as FormGroup).controls['type'].value;

    if (this.selectedQueType === 'productsList' && this.blockProductsListWithoutStripe()) {
      this.selectedQueType = currentType;
      return;
    }

    (this.questionsControls.controls[i] as FormGroup).controls['type'].setValue(this.selectedQueType);
    this.questionsList[i].type = this.selectedQueType
    this.questionsList[i].icon = this.questionIcons[this.selectedQueType].icon
    this.typeChange(this.selectedQueType, i);
    if (this.selectedQueType === 'customComponents') {
      this.questionsControls.at(i).get("components")['controls'] = []
      this.removeComponent(i, this.componentCurrentId)
      this.removeChoices(i, this.choicesCurrentInd)
      this.addComponent(i, this.componentCurrentId - 1)
    }
    if (this.selectedQueType === 'multipleChoice' || this.selectedQueType === 'uniqueChoice' || this.selectedQueType === 'requiredImages') {
      this.questionsControls.at(i).get("choices")['controls'] = []
      this.removeChoices(i, this.choicesCurrentInd)
      this.addChoices(i, -1);
    }
  }

  changeRequired(i: number, isChecked: boolean): void {
    const currentQuestion = this.questionsControls.at(i) as FormGroup;
    currentQuestion.controls['required'].setValue(isChecked);
  }

  get requiredControl(): FormControl | null {
    if (!this.questionsControls || this.currentStep >= this.questionsControls.length) {
      return null;  // Evitamos el error si el índice es inválido
    }
    return this.questionsControls.at(this.currentStep).get('required') as FormControl;
  }

  toggleImage(image) {
    this.selectedImage = this.selectedImage === image ? null : image;
  }

  uploadImage() {
    // Check if this is for a question image or choice image
    if (this.currentQuestionControl && this.currentQuestionIndex !== undefined) {
      // This is for a question image
      this.currentQuestionControl.get('image')?.setValue(this.selectedImage.path);
      this.currentQuestionControl = null;
      this.currentQuestionIndex = undefined;
    } else {
      // This is for a choice image (existing functionality)
      this.uploadControl.controls.image.setValue(this.selectedImage.path);
    }

    this.visible = false;
    this.selectedImage = undefined;
  }

  uploadFile() {
    this.uploadControl.controls.image.setValue(this.selectedImage.path);

    this.visible = false;
    this.selectedImage = undefined;
  }


  handleUpload(event, j, item) {
    const file = event.target.files[0];

    if (file) {
      const allowedFileTypes = ['image/jpeg', 'image/jpg', 'image/png'];
      if (!allowedFileTypes.includes(file.type)) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid file type. Please select a valid image file.' });
        event.target.value = '';

      } else {
        const reader = new FileReader();
        reader.onload = () => {
          const name = file.name;
          const base64 = reader.result.toString();
          const blob = base64.split(",")[1];
          Swal.showLoading()
          this.productService.uploadFile(name, blob).subscribe(
            (res: any) => {
              item.controls.image.setValue(res.fileUrl);
              Swal.close()
              // Set the selectedImageUrl for the specific item
              this.selectedImageUrl = res.fileUrl;
            },
            (error) => {
            }
          );
        };
        if (file) {
          reader.readAsDataURL(file);
        }
      }
    }
  }


  selectImage(event, item, j) {
    this.handleUpload(event, j, item);
  }


  get questionsControls() {
    return this.questionForm.get("questions") as FormArray;
  }

  choicesControls(id: number) {
    return this.questionsControls.at(id).get("choices") as FormArray;
  }

  componentsControls(id: number) {
    return this.questionsControls.at(id).get("components") as FormArray;
  }

  addComponents(id, component) {
    this.components = this.questionsControls.at(id).get('components') as FormArray;
    this.components.push(component);
  }

  optionControls(choiceInd: number, optInd: number): FormArray {
    const choiceGroup = this.questionsControls.at(choiceInd) as FormGroup; // FormGroup
    const choicesArray = choiceGroup.get('choices') as FormArray; // FormArray
    const optionGroup = choicesArray.at(optInd) as FormGroup; // FormGroup
    const optionsArray = optionGroup.get('options') as FormArray; // FormArray
    return optionsArray; // Devuelves un FormArray
  }

  addChoices(id, choicesInd): void {
    this.choices = this.questionsControls.at(id).get("choices") as FormArray;
    this.choicesCurrentInd = choicesInd + 1

    if (this.selectedType === 'multipleChoice' || this.selectedType === 'uniqueChoice') {
      this.choices.push(this.createChoices(''));
      this.addOption(id, this.choicesCurrentInd, this.optionCurrentInd)
    } else if (this.selectedType === 'requiredImages') {
      this.choices.push(this.createChoices(''));
      // No agregamos opciones para requiredImages, solo la imagen y título
    }
  }

  removeChoices(id, opId): void {
    this.choices = this.questionsControls.at(id).get("choices") as FormArray;
    this.choices.removeAt(opId);
    this.choicesCurrentInd = opId - 1
  }

  addComponent(id, componentId): void {
    // this.inputCustomForm = []

    if (id === this.currentStep) {
      const componentsArray = this.componentsControls(id);
      componentsArray.clear();
      this.customComponent.forEach((component) => {
        componentsArray.push(component.submit());
      });
    }
    this.components = this.componentsControls(id);

    this.componentCurrentId = componentId + 1;
    this.components.push(this.createComponent(''));
    this.inputCustomForm = this.components.getRawValue()
  }

  removeComponent(id, componentId): void {
    this.components = this.questionsControls.at(id).get("components") as FormArray;
    this.components.removeAt(componentId);
    this.componentCurrentId = componentId - 1;
    this.inputCustomForm = this.componentsControls(this.currentStep).getRawValue();
  }

  addOption(id, choicesInd, optInd) {
    const optionControls = this.questionsControls.at(id).get("choices") as FormArray;
    this.options = optionControls.at(choicesInd).get("options") as FormArray
    this.options.push(this.createOptions(''));
    this.optionCurrentInd = optInd + 1
  }

  removeOption(id, choicesInd, optInd) {
    const optionControls = this.questionsControls.at(id).get("choices") as FormArray;
    this.options = optionControls.at(choicesInd).get("options") as FormArray
    this.options.removeAt(optInd - 1);
    this.optionCurrentInd = optInd - 1
  }

  createQuestion(ele): FormGroup {
    return this.fb.group({
      id: [ele.id ? ele.id : ''], // Add support for unique identifier
      title: [ele.title ? ele.title : '', [Validators.required, CreateCustomFormComponent.noSpaceValidator()]],
      subtitle: [ele.subtitle ? ele.subtitle : ''],
      type: [ele.type ? ele.type : '', Validators.required],
      required: [ele.required ? ele.required : false],
      image: [ele.image ? ele.image : ''],
      hasImage: [!!ele.image],
      choices: this._getFormArrayFun(ele),
      logic: [ele.logic || []],
      options: [ele.options ? ele.options : ''],
      components: this._componentFormArray(ele?.components),
      products: [ele.products ? ele.products : ''],
      defaultFocus: [''],
      annotations: ['']
    });
  }

  private _componentFormArray(data): FormArray {
    let fa: FormArray = this.fb.array([])
    if (data?.length) {
      data.forEach((el) => {
        fa.controls.push(this.createComponent(el));
      })
    }
    return fa
  }

  createComponent(ele): FormGroup {
    return this.fb.group({
      image: [ele.image ? ele.image : ''],
      imageSize: [ele.imageSize ? ele.imageSize : 'medium'],
      imagePosition: [ele.imagePosition ? ele.imagePosition : 'top'],
      title: [ele.title ? ele.title : ''],
      numberInputWithLabels: [ele?.choices?.numberInputWithLabels ? ele?.choices?.numberInputWithLabels : []],
      dropdownWithLabel: [ele?.choices?.dropdownWithLabel ? ele?.choices?.dropdownWithLabel : []],
      checkboxWithLabel: [ele?.choices?.checkboxWithLabel ? ele?.choices?.checkboxWithLabel : []],
      radioButtons: [ele?.choices?.radioButtons ? ele?.choices?.radioButtons : []],
    });
  }

  private _getFormArrayFun(data): FormArray {
    let fa: FormArray = this.fb.array([])
    if (data?.choices?.length) {
      data.choices.forEach((el) => {
        if (el) {
          fa.controls.push(this._returnFormGroup(el))
        }
      })
    }
    return fa
  }

  private _returnFormGroup(ele): FormGroup {
    let fg = this.fb.group({
      image: [ele.image ? ele.image : '', Validators.required],
      title: [ele.title ? ele.title : ''],
      prescriptionTemplateId: [ele.prescriptionTemplateId ? ele.prescriptionTemplateId : null],
      options: this._optionFormArray(ele)
    })
    return fg
  }

  private _optionFormArray(data): FormArray {
    let fa: FormArray = this.fb.array([])
    if (data?.options?.length) {
      data.options.forEach((el) => {
        if (el) {
          fa.controls.push(this.createOptions(el))
        }
      })
    }
    return fa
  }

  createOptions(ele): FormGroup {
    return this.fb.group({
      name: [ele.name ? ele.name : '', Validators.required],
      isSelected: [ele.isSelected ? ele.isSelected : false],
    });
  }



  createChoices(ele): FormGroup {
    const titleValidators = this.selectedType === 'requiredImages' ? [Validators.required] : [];
    return this.fb.group({
      image: [ele.image ? ele.image : '', Validators.required],
      title: [ele.title ? ele.title : '', titleValidators],
      prescriptionTemplateId: [ele.prescriptionTemplateId ? ele.prescriptionTemplateId : null],
      options: this.fb.array([])
    });
  }



  createCustomComponent(ele): FormGroup {
    return this.fb.group({
      image: [ele.image ? ele.image : ''],
      title: [ele.title ? ele.title : ''],
      numberInputWithLabels: [ele?.numberInputWithLabels ? ele?.numberInputWithLabels : []],
      dropdownWithLabel: [ele?.dropdownWithLabel ? ele?.dropdownWithLabel : []],
      checkboxWithLabel: [ele?.checkboxWithLabel ? ele?.checkboxWithLabel : []],
      radioButtons: [ele?.radioButtons ? ele?.radioButtons : []],
    });
  }



  typeChange(event, index) {
    this.selectedType = event ? event : this.questions.controls[index].value.type
  }

  questionSubmit(): boolean {
    console.log("questionSubmit() iniciado");

    // PRIMERO: Sincronizar solo la pregunta actual si es customComponents
    if (this.selectedType === 'customComponents' && this.customComponent) {
      const componentsArray = this.questionsControls.at(this.currentStep).get("components") as FormArray;
      componentsArray.clear();
      this.customComponent.forEach((component) => {
        const componentFormGroup = component.submit();
        componentsArray.push(componentFormGroup);
      });
    }

    this.questionsControls.updateValueAndValidity();
    let error = false;

    // Validar si hay errores en los componentes personalizados
    if (this.selectedType === 'customComponents') {
      this.customComponent.forEach((component, index) => {
        const componentVal = component.submit();
        if (componentVal.invalid) {
          error = true;
        }
      });
    }

    // Verificar si el formulario completo es válido
    if (this.isInvalidForm(error)) {
      let errorMessage = 'Please fill all mandatory fields';
      if (error && this.selectedType === 'customComponents') {
        errorMessage = 'Please add options to all radio buttons, dropdowns, and checkboxes in your custom components';
      }
      this.messageService.add({ severity: 'error', summary: 'Error', detail: errorMessage });
      Swal.fire({
        title: 'Warning',
        text: 'Please fill all mandatory fields',
        icon: 'warning',
        confirmButtonText: 'Ok',
        confirmButtonColor: '#3085d6'
      });
      return false; // Retornar false si hay un error de validación
    }

    // Si hay componentes personalizados, resetearlos
    if (this.selectedType === 'customComponents') {
      this.resetComponents();
    }

    // Si ya estamos en el proceso de envío, no hacer nada
    if (this.isSubmitting) {
      return false;
    }

    this.isSubmitting = true;

    // Crear el payload con todos los datos del formulario
    let payload = this.createPayload();
    this.addClientToPayload(payload);

    // Enviar el formulario completo
    this.submitForm(payload);

    return true; // Si todo ha ido bien hasta este punto, retornamos true
  }

  isInvalidForm(error: boolean): boolean {
    const nameEmpty = this.questionForm.value.name === "";

    // Validar solo la pregunta actual en detalle
    const currentQuestionInvalid = this.currentStep >= 0 &&
      this.currentStep < this.questionsControls.length &&
      this.questionsControls.at(this.currentStep).invalid;

    // Para otras preguntas, solo verificar campos básicos (title y type)
    const otherQuestionsInvalid = this.questionsControls.controls.some((control, index) => {
      if (index === this.currentStep) return false; // Ya validamos la actual

      const questionGroup = control as FormGroup;
      const title = questionGroup.get('title')?.value;
      const type = questionGroup.get('type')?.value;

      // Una pregunta es inválida si no tiene título o tipo
      return !title || title.trim() === '' || !type;
    });

    return (
      nameEmpty ||
      error ||
      currentQuestionInvalid ||
      otherQuestionsInvalid
    );
  }

  resetComponents(): void {
    // Ya no necesitamos resetear aquí porque se hace en createPayload()
    // Solo mantenemos la referencia a this.components actualizada
    if (this.components) {
      this.components.clear();
    }
  }


  createPayload(): any {
    // Sincronizar solo el componente actual si estamos en una pregunta de customComponents
    if (this.selectedType === 'customComponents' && this.customComponent) {
      const currentQuestionControl = this.questionsControls.at(this.currentStep);
      if (currentQuestionControl && currentQuestionControl.value.type === 'customComponents') {
        const componentsArray = currentQuestionControl.get("components") as FormArray;
        componentsArray.clear();

        this.customComponent.forEach((component) => {
          const componentFormGroup = component.submit();
          componentsArray.push(componentFormGroup);
        });
        console.log("this.customComponent length:", this.customComponent.length);
        this.customComponent.forEach((component, index) => {
          const componentData = component.submit();
          console.log(`Componente ${index} data:`, componentData.value);
        });
      }
    }

    let payload = this.questionForm.getRawValue();

    if (this.userService.user.role == "ROLE_CUSTOMER") {

      this.clientId = this.userService.user.client.id
      console.log("Es customer, clientId: ", this.clientId)
      this.createCustomForm.value.clientId = this.clientId

      if (this.userService.user.connectedStripeId) {
        payload.connectedStripeId = this.userService.user.connectedStripeId
      }
    }

    // Ensure requireScans and requireWeb3DScans are set to false if they're null or undefined
    payload.requireScans = payload.requireScans !== null && payload.requireScans !== undefined
      ? payload.requireScans
      : false;

    payload.requireWeb3DScans = payload.requireWeb3DScans !== null && payload.requireWeb3DScans !== undefined
      ? payload.requireWeb3DScans
      : false;

    payload.required.name = this.requireNameControl.value
    payload.required.surname = this.requireSurnameControl.value
    payload.required.shoeSize = this.requireShoeSizeControl.value
    payload.required.video = this.requireVideoControl.value
    payload.clinicId = this.clinicIdControl.value
    payload.clientId = this.clientId ?? null
    payload.scanningType = this.scanningTypeControl.value
    payload.enableShipping = this.enableShippingControl.value ?? false

    payload.questions = this.questionsControls.getRawValue();

    // Debug: Log para verificar que prescriptionTemplateId está presente
    console.log('Payload questions before processing:', JSON.stringify(payload.questions, null, 2));

    payload.questions.forEach((question) => {
      if (question.type === 'customComponents') {
        question.components.forEach((component, index) => {
          // component ya es el valor del FormGroup, no necesitamos reestructurar
          const newComponent = {
            title: component.title,
            image: component.image,
            imageSize: component.imageSize || 'medium',
            imagePosition: component.imagePosition || 'top',
            choices: {
              numberInputWithLabels: component.numberInputWithLabels || [],
              dropdownWithLabel: component.dropdownWithLabel || [],
              checkboxWithLabel: component.checkboxWithLabel || [],
              radioButtons: component.radioButtons || [],
            }
          };
          question.components[index] = newComponent;
        });
      }

      // Asegurar que prescriptionTemplateId se mantenga en uniqueChoice choices
      if (question.type === 'uniqueChoice' && question.choices) {
        question.choices = question.choices.map(choice => ({
          image: choice.image,
          title: choice.title,
          prescriptionTemplateId: choice.prescriptionTemplateId || null,
          options: choice.options || []
        }));
      }
    });

    // Remove empty choices, options, or components
    payload.questions.forEach((ele) => {
      if (ele.choices && ele.choices.length === 0) {
        delete ele['choices'];
      }
      if (ele.options && ele.options.length === 0) {
        delete ele['options'];
      }
      if (ele.components && ele.components.length === 0) {
        delete ele['components'];
      }
    });

    return payload;
  }

  addClientToPayload(payload: any): void {
    if (this.selectedClient && this.selectedClient.length > 0) {
      payload.assignedToCustomers = this.selectedClient.length === this.clientList.length
        ? ["*"]
        : this.selectedClient.map(({ ID }) => ID);
    }
  }

  submitForm(payload: any): void {
    const formAction = this.isEdit
      ? this.customerFormService.updateCustomForm(this.editedItem.ID, payload)
      : this.customerFormService.addCustomForm(payload);

    // Suscripción al observable, manejando el éxito y el error
    formAction.subscribe({
      next: async (res) => {
        this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form has been updated successfully' });
        this.isQuestionPopup = false;
        this.formClear();
        this.isSubmitting = false;
        this.backToCustomFormsList()
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: err?.error?.message });
        this.isSubmitting = false;
      }
    });
  }


  onScanAccessChange(checked: boolean) {
    // Update the value of the form control programmatically
    this.questionForm.get('requireScans').setValue(checked);
  }

  closePopup(): void {
    this.isQuestionPopup = false
    this.isEdit = false
    this.editedItem = []
    this.formClear()
    this.search = ''
    this.getAllCustomForm();
  }

  getAllCustomForm(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.customerFormService.getCustomForm().subscribe({
        next: (res) => {
          this.customFormList = res;
          this.filteredFormList = res;
          this.loading = false;
          resolve();
        },
        error: (err) => {
          console.error("Error getting custom forms: ", err);
          reject(err);
        }
      });
    });
  }


  deleteForm(id: string, event: Event) {
    event.stopPropagation();
    if (this.isDeleting) {
      return;
    }
    this.isDeleting = true;
    this.customerFormService.deleteCustomForm(id).subscribe((res) => {
      const index = this.customFormList.findIndex((question) => question.ID === id);
      this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form has been deleted successfully' });
      this.customFormList.splice(index, 1);
      this.getAllCustomForm();
      this.isDeleting = false;
    });
  }

  formClear() {
    this.questionForm.reset()
    this.selectedType = ' '
    this.isEdit = false
    this.editedItem = []
    const questionArry = this.questionForm.get('questions') as FormArray;
    questionArry.controls = [];
    this.selectedQueType = '';
    this.isRequiredQue = false;
    this.questionsList = [];
    this.search = ''
  }

  editValue(item, index) {
    this.choicesCurrentInd = -1
    this.optionCurrentInd = -1
    this.editedItem = item
    this.isQuestionPopup = true
    this.isEdit = true

    this.selectedClient = []

    // Asignar todos los clientes si 'assignedToCustomers' es un asterisco ('*')
    if (item.assignedToCustomers && item.assignedToCustomers[0] === '*') {
      this.selectedClient = [...this.clientList];  // Clonar todos los clientes
    } else if (item.assignedToCustomers && Array.isArray(item.assignedToCustomers)) {
      // Si no es un asterisco, asignar solo los clientes especificados en 'assignedToCustomers'
      item.assignedToCustomers.map((customerId) => {
        let foundClient = this.clientList.find((client) => client.ID === customerId);
        if (foundClient) {
          console.log("Pusheamos client a selectedClient list")
          this.selectedClient.push(foundClient);
        } else {
          console.warn(`Cliente con ID ${customerId} no encontrado en la lista de clientes.`);
        }
      });
    } else {
      console.warn('No hay clientes asignados o el formato de "assignedToCustomers" es incorrecto.');
    }


    this.questionForm.patchValue({
      name: item.name,
      userId: item.userId,
      requireScans: item.requireScans,
      requireWeb3DScans: item.requireWeb3DScans || false,
      required: {
        name: item.required?.name || false,
        surname: item.required?.surname || false,
        shoeSize: item.required?.shoeSize || false,
        video: item.required?.video || false
      },
      enableShipping: item.enableShipping,
      clinicId: item.clinicId,
      scanningType: item.scanningType
    }, { emitEvent: false });
    this.updateForm.patchValue({
      name: item.name.trim()
    })
    this.selectedType = item.questions[index]?.type;
    this.selectedQueType = item.questions[index]?.type;
    this.questions = this.questionForm.get('questions') as FormArray;
    item.questions.forEach((question, q_index) => {
      this.questionsControls.controls.push(this.createQuestion(question))
    })
    if (this.selectedType === 'productsList') {
      this.questionsControls.at(index).get('products').setValue(item.questions[index].products);
    }
    item.questions.forEach((element, index) => {
      if (this.questionIcons && this.questionIcons[element.type]) {
        let questions = ({ ...element, ...this.questionIcons[element.type] })
        this.questionsList.push(questions)
      }
    });

    // Asignar inputCustomForm basado en la pregunta actual
    if (this.selectedType === 'customComponents') {
      // Obtener los datos originales del servidor, no del FormGroup
      this.inputCustomForm = item.questions[index].components || [];
      this.cd.detectChanges();
    }

    this.itemsUpdate(index);
  }

  itemsUpdate(index) {
    this._updateIndices(index);
  }

  private _updateIndices(questionIndex: number) {
    if (this.questionsControls && this.questionsControls.length > questionIndex) {
      const question = this.questionsControls.at(questionIndex);

      // Update choices index
      const choices = question.get('choices') as FormArray;
      if (choices) {
        this.choicesCurrentInd = choices.length - 1;
      } else {
        this.choicesCurrentInd = -1;
      }

      // Update components index if needed
      const components = question.get('components') as FormArray;
      if (components) {
        this.componentCurrentId = components.length - 1;
      } else {
        this.componentCurrentId = -1;
      }
    }
  }

  removeItem(i: number): void {
    if (this.questionsList && this.questionsList.length > 0) {
      this.questionsList.splice(i, 1);

      this.questions = this.questionForm.get('questions') as FormArray;

      if (this.questions && i >= 0 && i < this.questions.length) {
        this.questions.removeAt(i);
      }

      this.backQuestion();
      this.selectedQueType = this.questionForm.value.questions[this.currentStep].type;
    }
  }


  scanAccess() {
    if (this.userService.user.role === "ROLE_CUSTOMER" && (this.questionForm.value.requireScans)) {
      this.isScnAccess = true
      this.scanLink = environment.base_url_second + '/email=' + this.userService.user.email + '&uuid=' + this.userService.user.ID
    } else {
      this.isQuestionPopup = false
    }
  }

  scanBack() {
    this.isScnAccess = false
    this.isQuestionPopup = false
  }

  /**
   * Create Custom form
   */
  private _initCreateCustomForm(): void {
    this.createCustomForm = this.fb.group({
      name: ['', [Validators.required, CreateCustomFormComponent.noSpaceValidator()]],
      userId: [''],
      requireScans: [false],
      assignedToCustomers: new FormArray([]),
      questions: new FormArray([])
    })
  }

  private _initUpdateForm(): void {
    // Initialize the update form with the required and custom validators
    this.updateForm = this.fb.group({
      name: ['', [Validators.required, CreateCustomFormComponent.noSpaceValidator(), Validators.maxLength(50),
      Validators.minLength(3)]],
    });
  }

  /**
   * Create New Form
   */
  public createNewForm() {

    if (this.createCustomForm.value.name === "" || this.createCustomForm.value.name === null || this.createCustomForm.invalid) {
      this.createCustomForm?.markAllAsTouched();
      return;
    }

    if (this.isFormSubmitting) {
      return;
    }

    this.isFormSubmitting = true;

    // Ensure requireScans is set to false if it's null or undefined
    const payload = {
      ...this.createCustomForm.value,
      requireScans: this.createCustomForm.value.requireScans !== null && this.createCustomForm.value.requireScans !== undefined
        ? this.createCustomForm.value.requireScans
        : false
    };


    this.customerFormService.addCustomForm(payload).subscribe({
      next: async (res) => {
        if (res['ID']) {
          await this.getAllCustomForm();

          const customItem = this.customFormList.filter((item) => item.ID === res['ID']);

          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form has been created successfully' });
          this.showCustomFormPopup = false;
          this.isFormSubmitting = false;

          if (customItem.length > 0) {
            this.editValue(customItem[0], 0);
          }
        }
      },
      error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'error', detail: err?.error?.message });
        this.showCustomFormPopup = false;
        this.isFormSubmitting = false;
      }
    });
  }

  public updateFormName() {
    if (this.updateForm.invalid) return
    else {
      if (this.isFormNameSubmitting) {
        return;
      }

      this.isFormNameSubmitting = true;

      const payload = {
        name: this.updateForm.value.name
      }

      this.customerFormService.updateCustomFormName(this.editedItem.ID, payload).subscribe({
        next: async (res) => {
          await this.getAllCustomForm();
          this.isFormNameSubmitting = false;
          this.isInputChanged = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Form name has been updated successfully' });
        },
        error: (err) => {
          this.messageService.add({ severity: 'error', summary: 'error', detail: err?.error?.message });
          this.isInputChanged = false;
          this.showCustomFormPopup = false;
          this.isFormNameSubmitting = false;
        }
      });
    }
  }

  loadClient() {
    if (this.user.role === Roles.ROLE_CUSTOMER || this.user.role === Roles.ROLE_CLINIC) {
      let getClientDTO

      // Si es role_customer o role_clinic busca el client adecuado (desde el back le añadimos el user la propiedad client, lo obtenemos desde el renewToken)
      if (this.user && this.user.client) {
        getClientDTO = this.user.client.email
      }

      this.clientsService.getClient(getClientDTO).subscribe({
        next: (clientFound) => {
          this.client = clientFound;
          this.getClinicsByClientID();

        },
        error: (err) => {
          console.error('Error fetching client:', err);
        }
      });
    }

  }

  getClinicsByClientID() {
    this.clinics = []
    this.clinicService.getClinicsByClientId(this.client.ID).subscribe((data) => {
      // Obtenemos las clínicas y ordenamos la lista para poner en primer lugar la default clinic
      this.clinics = data.sort((a, b) => (b.default ? 1 : -1) - (a.default ? 1 : -1));
    })
  }

  /**
   * Set Form Value 
   * @param value : input Value
   */
  public setValueinFormName(eventTarget): void {
    const value = eventTarget.value
    this.updateForm.get('name').patchValue(value);
    this.isInputChanged = true;
  }

  //clientSelected
  public clientSelected() {
    console.log('selectedClient', this.selectedClient)
  }

  static noSpaceValidator(): ValidatorFn {
    return (control: AbstractControl) => {
      const value = control.value;
      if (value && value.toString().startsWith(' ')) {
        return { noWhiteSpaceValidator: true };
      }
      return null;
    };
  }

  // Función para filtrar los datos basados en el search
  applyFilter() {
    this.filteredFormList = this.customFormList.filter(item =>
      item.name.toLowerCase().includes(this.search.toLowerCase())
    );
  }

  backToCustomFormsList() {
    this.router.navigate([`/custom-forms`])
  }

  updateImageControl(): void {
    if (this.questionsControls && this.questionsControls.length > this.currentStep) {
      const currentQuestion = this.questionsControls.at(this.currentStep) as FormGroup;
      this.imageControl = currentQuestion.get('image') as FormControl;
    } else {
      this.imageControl = new FormControl(false);
    }
  }

  changeImage(questionIndex: number, isChecked: boolean): void {
    const currentQuestion = this.questionsControls.at(questionIndex) as FormGroup;
    currentQuestion.get('image')?.setValue(isChecked);

    // If unchecked, clear the image
    if (!isChecked) {
      currentQuestion.get('image')?.setValue('');
    }
  }

  getQuestionImageUrl(): string {
    if (this.questionsControls && this.questionsControls.length > this.currentStep) {
      const currentQuestion = this.questionsControls.at(this.currentStep) as FormGroup;
      const imageValue = currentQuestion.get('image')?.value;
      return imageValue && imageValue.length ? imageValue : 'assets/images/no-image.png';
    }
    return 'assets/images/no-image.png';
  }

  showQuestionImageDialog(position: string, control: any): void {
    this.position = position as DialogPosition;
    this.visible = true;
    this.uploadControl = control;
  }

  getChoicesForCurrentQuestion(): any[] {
    if (this.currentStep >= 0 && this.questionsControls && this.questionsControls.length > this.currentStep) {
      const currentQuestionControl = this.questionsControls.at(this.currentStep) as FormGroup;
      const questionType = currentQuestionControl.get('type')?.value;

      if (questionType === 'uniqueChoice') {
        const choicesArray = currentQuestionControl.get('choices') as FormArray;
        if (choicesArray && choicesArray.length > 0) {
          const allOptions: any[] = [];

          // Iterar sobre cada choice y extraer sus opciones
          for (let i = 0; i < choicesArray.length; i++) {
            const choiceGroup = choicesArray.at(i) as FormGroup;
            const optionsArray = choiceGroup.get('options') as FormArray;

            if (optionsArray && optionsArray.length > 0) {
              for (let j = 0; j < optionsArray.length; j++) {
                const optionGroup = optionsArray.at(j) as FormGroup;
                const optionName = optionGroup.get('name')?.value;
                if (optionName) {
                  allOptions.push({ name: optionName });
                }
              }
            }
          }

          return allOptions;
        }
      }
    }
    return [];
  }

  getAvailableQuestions(): any[] {
    if (!this.questionsControls || this.questionsControls.length === 0) {
      return [];
    }

    const questions: any[] = [];

    for (let i = 0; i < this.questionsControls.length; i++) {
      const questionControl = this.questionsControls.at(i) as FormGroup;
      const title = questionControl.get('title')?.value || 'Untitled';

      questions.push({
        label: `${i + 1}. ${title}`,
        index: i
      });
    }

    return questions;
  }

  getCurrentQuestionLogic(): any[] {
    if (this.currentStep >= 0) {
      const currentQuestionControl = this.questionsControls.at(this.currentStep);
      return currentQuestionControl.get('logic')?.value || [];
    }
    return [];
  }

  removeLogicRule(index: number): void {
    if (this.currentStep >= 0) {
      const currentQuestionControl = this.questionsControls.at(this.currentStep);
      const currentLogic = currentQuestionControl.get('logic')?.value || [];
      currentLogic.splice(index, 1);
      currentQuestionControl.get('logic')?.setValue([...currentLogic]);
    }
  }

  updateQuestionLogic(): void {
    if (this.currentStep >= 0) {
      const currentQuestionControl = this.questionsControls.at(this.currentStep);
      const currentLogic = currentQuestionControl.get('logic')?.value || [];

      // Si solo hay un campo lleno, no hacer nada
      if (!this.selectedLogicOption || this.selectedGoToQuestion === null || this.selectedGoToQuestion === undefined) {
        return;
      }

      // Buscar si ya existe una regla para esta opción
      const existingRuleIndex = currentLogic.findIndex((rule: any) => rule.selectedOption === this.selectedLogicOption);

      const newRule = {
        condition: "If",
        selectedOption: this.selectedLogicOption,
        goToIndex: this.selectedGoToQuestion
      };

      if (existingRuleIndex >= 0) {
        // Actualizar regla existente
        currentLogic[existingRuleIndex] = newRule;
      } else {
        // Agregar nueva regla
        currentLogic.push(newRule);
      }

      currentQuestionControl.get('logic')?.setValue([...currentLogic]);

      // Limpiar los campos después de agregar
      this.selectedLogicOption = null;
      this.selectedGoToQuestion = null;
    }
  }

  clearAllPrescriptionTemplates(): void {
    // Recorrer todas las preguntas
    const questionsArray = this.questionForm.get('questions') as FormArray;

    questionsArray.controls.forEach((questionControl: FormGroup) => {
      const questionType = questionControl.get('type')?.value;

      // Solo procesar uniqueChoice que tienen choices
      if (questionType === 'uniqueChoice') {
        const choicesArray = questionControl.get('choices') as FormArray;

        if (choicesArray) {
          // Recorrer todas las choices y limpiar prescriptionTemplateId
          choicesArray.controls.forEach((choiceControl: FormGroup) => {
            const prescriptionTemplateIdControl = choiceControl.get('prescriptionTemplateId');
            if (prescriptionTemplateIdControl) {
              prescriptionTemplateIdControl.setValue(null);
            }
          });
        }
      }
    });
  }

  addWeb3DScansQuestions(): void {
    const questionsArray = this.questionForm.get('questions') as FormArray;

    // Check if these questions already exist to avoid duplicates using unique IDs
    const hasName = questionsArray.controls.some(c => c.value.id === 'patient_name');
    const hasSurname = questionsArray.controls.some(c => c.value.id === 'patient_surname');
    const hasGender = questionsArray.controls.some(c => c.value.id === 'patient_gender');

    // If any of them already exist, don't add them again
    if (hasName || hasSurname || hasGender) {
      return;
    }

    // 1. Gender (Unique Choice)
    const genderQuestion = this.createQuestion({
      id: 'patient_gender',
      title: 'Gender',
      type: 'uniqueChoice',
      required: true,
      choices: [
        {
          title: 'Male',
          image: 'assets/images/icon-male-375.png',
          options: [{ name: 'Male', isSelected: false }]
        },
        {
          title: 'Female',
          image: 'assets/images/icon-female-375.png',
          options: [{ name: 'Female', isSelected: false }]
        }
      ]
    });

    // 2. Surname (Input Text)
    const surnameQuestion = this.createQuestion({
      id: 'patient_surname',
      title: 'Surname',
      type: 'inputText',
      required: true
    });

    // 3. Name (Input Text)
    const nameQuestion = this.createQuestion({
      id: 'patient_name',
      title: 'Name',
      type: 'inputText',
      required: true
    });

    // Insert in reverse order to keep them at the top: Name, Surname, Gender
    questionsArray.insert(0, genderQuestion);
    questionsArray.insert(0, surnameQuestion);
    questionsArray.insert(0, nameQuestion);

    // Update questions list for UI (sidebar/preview)
    this.updateQuestionsList();
  }

  removeWeb3DScansQuestions(): void {
    const questionsArray = this.questionForm.get('questions') as FormArray;

    // Helper to find index by unique ID instead of title
    const findIndexById = (id: string) => {
      return questionsArray.controls.findIndex(c => c.value.id === id);
    };

    const nameIndex = findIndexById('patient_name');
    if (nameIndex !== -1) questionsArray.removeAt(nameIndex);

    const surnameIndex = findIndexById('patient_surname');
    if (surnameIndex !== -1) questionsArray.removeAt(surnameIndex);

    const genderIndex = findIndexById('patient_gender');
    if (genderIndex !== -1) questionsArray.removeAt(genderIndex);

    this.updateQuestionsList();
  }

  updateQuestionsList(): void {
    // Rebuild questionsList based on current form array
    this.questionsList = [];
    const questionsArray = this.questionForm.get('questions') as FormArray;
    questionsArray.controls.forEach((control: FormGroup, index) => {
      const type = control.value.type;
      if (this.questionIcons && this.questionIcons[type]) {
        const element = control.value;
        let questionItem = ({ ...element, ...this.questionIcons[type], command: () => this.moveToQuestion(index + 1) });
        // Note: moveToQuestion expects 1-based index in some contexts or 0-based? 
        // Looking at valid usage: 
        // selectQuestionType: this.questionsList = [...this.questionsList, { ..., command: () => this.moveToQuestion(this.selectedQueIndex) }];
        // selectedQueIndex = this.questionsList.length + 1;
        // So it seems it might be using updated indices.
        // Let's just replicate what 'editValue' does.

        this.questionsList.push(questionItem);
      }
    });

    console.log('All prescription templates cleared');
  }
}
